module.exports = __webpack_public_path__ + "assets/img/logo-error.2412391f.png";